export const capitalize = (value) => {
	if (!value) return '';

	const str = value.toString();

	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * nullableToDashFormat
 * @param {String|Number} value
 * @returns {String|Number}
 */
export const nullableToDashFormat = (value) => {
	if (!value && value !== 0) {
		return '-';
	}
	return value;
};

export const filterCaseClub = (value) => {
	if (!value) {
		return null;
	}
	if (value.toLowerCase() === 'caseclub' || value.toLowerCase() === 'case club') {
		return true;
	}
	return false;
};
